import colors from './appColors'

export type ButtonContentColors = {
  text: string
  icon: string
  spinner: string
}

/**
 * Content colors for an ENABLED button filled with `colors.PRIMARY`.
 *
 * `colors.PRIMARY` is tenant-switched (SportNinja `#F2B400` amber, Canlan
 * `#004FFF` blue), so the content sitting on top of it must switch too:
 * dark `#181d26` on SportNinja, white `#FFFFFF` on Canlan.
 *
 * Derived from `colors.PRIMARY_TEXT` rather than redefining the hexes, so the
 * tenant switch stays in one place (`appColors.js`).
 *
 * Text, icon and spinner are separate fields even though they currently
 * resolve to the same value — they are semantically distinct, and consuming
 * them as an object is what keeps icon color from being forgotten at the
 * call site.
 *
 * Only applies to a `colors.PRIMARY` fill. Does NOT apply to disabled buttons
 * (which override the fill away from PRIMARY), outlined/ghost buttons (where
 * PRIMARY is the text color on a transparent background), or `DEFAULT_FLAIR`
 * fills.
 */
export const PRIMARY_BUTTON_CONTENT: ButtonContentColors = {
  text: colors.PRIMARY_TEXT,
  icon: colors.PRIMARY_TEXT,
  spinner: colors.PRIMARY_TEXT,
}

export default PRIMARY_BUTTON_CONTENT
